import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { NarrowContainer } from "components/Containers";
import { PrimaryLink } from "components/Links";
import { useProfile } from "hooks";
import { BANNER_TYPE, MISSION_ROLE_STATES, APPLICANT_TYPES } from "constants/index";
import { Banner } from "components/Banner";

/**
 * ApplicantRoleUnavailable
 *
 * @param {Object}    application
 * @param {Boolean}   isMember
 */
const ApplicantRoleUnavailable = ({ application, isMember }) => {
  if (!application) return null;

  const role = application.missionRole;
  const { abandonRoleVetting } = useProfile({ skip: true });
  const userNotSelected = application.state === APPLICANT_TYPES.unselected;
  const roleClosed = role.state === MISSION_ROLE_STATES.closed;

  const handleAbandon = useCallback(async () => await abandonRoleVetting(application.profile.id), [role, application]);

  if (!roleClosed && !userNotSelected) return null;

  return (
    <Banner type={BANNER_TYPE.warning} isClosable={false} topMargin>
      <NarrowContainer>
        <FormattedMessage
          id={`Missions.Applicants.ApplicantRole${roleClosed ? `Unavailable` : `NotSelected`}${
            isMember ? `.Member` : ``
          }`}
          values={{
            intro: (
              <b>
                <FormattedMessage
                  id={`Missions.Applicants.ApplicantRole${roleClosed ? `Unavailable` : `NotSelected`}.Intro${
                    isMember ? `.Member` : ``
                  }`}
                />
              </b>
            ),
            link: (
              <PrimaryLink onClick={handleAbandon}>
                <FormattedMessage id={"Missions.Applicants.ApplicantAbandon.Cta"} />
              </PrimaryLink>
            ),
          }}
        />
      </NarrowContainer>
    </Banner>
  );
};

ApplicantRoleUnavailable.propTypes = {
  application: PropTypes.object.isRequired,
  isMember: PropTypes.bool,
};

export default ApplicantRoleUnavailable;
